<template>
  <a-row :gutter="24">
    <a-col :span="8">
      <tree
        ref="tree"
        @handleSelect="handleSelect"
        @handUpdateTrees="handUpdateTrees"
      />
    </a-col>

    <a-col :span="16">
      <a-card :bordered="false">
        <a-tabs v-if="modal && modal.id">
          <a-tab-pane key="1" tab="基本信息">
            <a-form :form="form">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="标题"
              >
                <a-input
                  v-decorator="[
                    'name',
                    { rules: [{ required: true, message: '请填写标题' }] }
                  ]"
                ></a-input>
              </a-form-item>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="所属栏目"
              >
                <a-tree-select
                  v-decorator="['partentId']"
                  :treeData="$store.getters.resource.resource"
                  :replaceFields="replaceFields"
                >
                </a-tree-select>
              </a-form-item>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="排序"
              >
                <a-input
                  v-decorator="[
                    'sort',
                    {
                      initialValue: '1',
                      rules: [{ required: true, message: '请填写排序' }]
                    }
                  ]"
                ></a-input>
              </a-form-item>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="是否在首页显示"
              >
                <a-select
                  v-decorator="[
                    'isDisplay',
                    {
                      initialValue: 'N',
                      rules: [{ required: true, message: '请选择是否首页显示' }]
                    }
                  ]"
                >
                  <a-select-option key="Y" value="Y">是</a-select-option>
                  <a-select-option key="N" value="N">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="是否对外开放"
              >
                <a-radio-group
                  v-decorator="[
                    'externalShow',
                    {
                      initialValue: value,
                      rules: [{ required: true, message: '请选择是否对外展示' }]
                    }
                  ]"
                  name="externalShow"
                >
                  <a-radio value="N">否</a-radio>
                  <a-radio value="Y">是</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item
                label="logo上传"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
              >
                <a-upload
                  v-decorator="[
                    'logo',
                    {
                      valuePropName: 'file',
                      getValueFromEvent: uploadHead
                    }
                  ]"
                  name="files"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :multiple="false"
                  :action="uploadURL"
                  :headers="headers"
                >
                  <img
                    v-if="form.getFieldValue('logo')"
                    class="userHead"
                    :src="form.getFieldValue('logo')"
                    alt="userHead"
                  />
                  <div v-else>
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
              </a-form-item>
            </a-form>
            <a-divider></a-divider>
            <div class="table-operator" style="text-align: center">
              <a-button type="primary" @click="save">保存</a-button>
              <a-button type="default" @click="reset">重置</a-button>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
// 工具类
import storage from "store";
import { USER_TOKEN } from "@/store/mutation-types";
import pick from "lodash.pick";
// 组件
import tree from "./modules/tree";
// api
import { findById, save } from "@/api/base/tree/manager";

export default {
  components: {
    tree
  },

  data() {
    return {
      //modal
      modal: {},
      //form
      form: this.$form.createForm(this),
      labelCol: { span: 5 },
      wrapperCol: { span: 15 },
      //upload
      uploadURL: window._CONFIG["uploadURL"], //上传路径
      headers: { user_token: storage.get(USER_TOKEN) },
      //selectTree
      treeData: [],
      editTree: [],
      replaceFields: {
        children: "jtypes",
        title: "name",
        key: "id",
        value: "id"
      },
      value: ""
    };
  },

  created() {
    this.$store.dispatch("resource");
  },

  methods: {
    check(val) {
      this.checked = val;
    },
    // 树更新事件处理
    handUpdateTrees(data) {
      this.treeData = data;
    },

    // 树点击事件
    handleSelect(id) {
      let params = { id: id };
      findById({ ...params }).then(res => {
        this.modal = res.result;
        this.value = res.result.externalShow;
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(this.modal, "name", "partentId", "sort", "logo", "isDisplay")
          );
        });
      });

      // 禁用当前id项
      this.setTreeDisabledAttr(this.editTree, id);
    },

    // 设置节点属性，将制定id设置为禁用
    setTreeDisabledAttr(items, id) {
      let _this = this;

      items.map(item => {
        item.disabled = item.id === id ? true : false;
        if (item.jtypes) {
          _this.setTreeDisabledAttr(item.jtypes, id);
        }
      });
    },

    // 背景上传
    uploadHead({ file }) {
      if (file.status == "uploading") {
        return;
      }
      if (file.status == "done" && file.response) {
        let path = file.response.result[0].filePath;
        return path;
      }
    },

    save() {
      let _this = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = Object.assign(this.modal, values);
          save({ ...params }).then(res => {
            this.$notification[res.resultCode == 1 ? "success" : "error"]({
              message: res.message
            });

            // 重新加载目录树
            if (1 == res.resultCode) {
              _this.$store.dispatch("resource");
            }
          });
        }
      });
    },

    reset() {
      this.form.resetFields();
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.modal, "name", "partentId", "sort", "describes", "logo")
        );
      });
    }
  }
};
</script>
<style scoped>
.avatar-uploader > .ant-upload {
  width: 115px;
  height: 115px;
}

.avatar-uploader .userHead {
  max-width: 115px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
